<div id="links">
    <ul>
        <li><a class="random-nonogram" href="#">Play a random nonogram</a></li>
        <li><a class="settings" href="#">Change settings</a></li>
        <li><a href="https://github.com/freak532486/NonoJs" target="_blank" rel="noopener noreferrer">Check out the source code.</a></li>
    </ul>
</div>